// extracted by mini-css-extract-plugin
module.exports = {"container":"Dialog_container__T9MVZ"};